import { Form, Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { InfoCard2 } from '../../../../widgets/components/UI/InfoCard2'
import { Formik } from 'formik'
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'
// import {ToolTipUI} from '../../widgets/components/UI/ToolTipUI'
import TextInput from '../../../../widgets/components/Input/TextInput'
import { SelectInput } from '../../../../widgets/components/Input/SelectInput'
import deleteicon from '../../../../../../media/stakeholders/ic-delete.svg'
import { ToolTipUIForModal } from '../../../../widgets/components/UI/ToolTipUIForModal'
import * as Yup from 'yup'
import { useCurrency } from '../../../../../hooks/useCurrency'
import { useAuth } from '../../../../auth'
import {
  conversionParametersOptions,
  participatingOptions,
  seniorityOptions,
} from '../../core/_constants'
import SelectSearchInput from '../../../../widgets/components/Input/SelectSearchInput'
import {
  createShareSecurityClass,
  getShareSecurityClassById,
  updateShareSecurityClass,
} from '../../core/_requests'
import { toast } from 'react-toastify'
import Skeleton from 'react-loading-skeleton'
import { getFileType } from '../../../../../core/_util'
import { FileUpload } from '../../../../widgets/components/FileUpload'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../../../../app/hooks/gtmHelpers'
import { allowedFileTypes } from '../../../../../core/_constants'
import { DeleteFileConfirmationModal } from '../../../components/delete-file-confirmation-modal'
import { TransactionModalType } from '../../core/_models'
import { useStakeholders } from '../../../Stakeholders'
import brandingConfig from '../../../../../../config/brandingConfig'

export default function AddSharedClassModal({
  isActive,
  setIsActive,
  shareClassId,
  setIsCreateOrUpdate,
  setSidebar,
  shareClassDropdown,
  setShareClassDropdown,
  openModal,
  modalType,
  setModalType,
  setShareClassId,
}: {
  isActive: boolean
  setIsActive: () => void
  shareClassId?: string | null
  setIsCreateOrUpdate: Dispatch<SetStateAction<boolean>>
  setSidebar: Dispatch<SetStateAction<number>>
  shareClassDropdown?: boolean
  setShareClassDropdown?: Dispatch<SetStateAction<boolean>>
  setShareClassId?: Dispatch<SetStateAction<string | null>>
  openModal?: (modalType: TransactionModalType) => void
  modalType?: string
  setModalType?: Dispatch<SetStateAction<TransactionModalType>>
}) {
  const { formatMessage } = useIntl()
  const [currentDocumentStep, setCurrentDocumentStep] = useState(1)
  const formikRef = useRef<any>(null)
  const { currencyOptions } = useCurrency()
  const { companyCurrency, companyId, currentUser } = useAuth()
  const [shareSecurityClassDetails, setShareSecurityClassDetails] = useState<any>(null)
  const [files, setFiles] = useState<any>([])
  const [isNotInitialized, setIsNotInitiaized] = useState(true)
  const [isLoading, setLoading] = useState<boolean>(false)
  const [shareClassDetailsLoading, setShareClassDetailsLoading] = useState<boolean>(false)
  const [modelStatus, setModelStatus] = useState<boolean>(false)
  const fileRef = useRef<any>([])
  const [deleteFileId, setDeleteFileId] = useState<any>(null)
  const [showDeleteModal, setDeleteShowModal] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const { setCreatedShareClassFromOtherClasses } = useStakeholders()

  const validationSchema = [
    Yup.object().shape({
      shareType: Yup.string().nullable().required('Class type is required'),
      className: Yup.string()
        .nullable()
        .required('Class name is required')
        .max(30, 'Class name must not exceed 30 characters'),
      tagColor: Yup.string().nullable().required('Tag color is required'),
      classCode: Yup.string().nullable().max(30, 'Class name must not exceed 30 characters'),
      pricePerShare: Yup.number()
        .nullable()
        .required('Price per share is required')
        .min(1, "Price per share can't be negative or 0")
        .test('max-length', 'Price per share must not exceed 20 characters', (value) =>
          value ? value.toString().length <= 20 : true
        ),
      votePerShare: Yup.number()
        .nullable()
        .min(0, 'VotePerShare must be a positive number')
        .test('max-length', 'vote  per share must not exceed 20 characters', (value) =>
          value ? value.toString().length <= 20 : true
        ),
      parValue: Yup.number()
        .nullable()
        .min(0, 'ParValue must be a positive number')
        .test('max-length', 'par value must not exceed 20 characters', (value) =>
          value ? value.toString().length <= 20 : true
        ),
      firstClosingDate: Yup.string().nullable().required('First closing date is required'),
    }),
    Yup.object().shape({
      seniorityLevel: Yup.object().nullable().required('Seniority level is required'),
      multiplier: Yup.number()
        .nullable()
        .required('Multiplier is required')
        .min(0, 'Multiplier must be a positive number'),
      participating: Yup.object().nullable().required('Participating cap is required'),
      conversionParameter: Yup.object().nullable().required('Conversion parameter is required'),
      participatingCap: Yup.number()
        .nullable()
        .min(0, 'ParticipatingCap must be a positive number')
        .when('participating.value', {
          is: 'yes',
          then: Yup.number().required('Participating cap is required'),
          otherwise: Yup.number().nullable(),
        }),
      conversionParameterValue: Yup.number()
        .nullable()
        .required('Conversion parameter value is required')
        .min(0, 'conversion Parameter value must be a positive number'),
    }),
  ]
  const [currentSchema, setCurrentSchema] = useState(validationSchema[0])

  const initialValues = {
    shareType: shareSecurityClassDetails?.shareType || 'common',
    className: shareSecurityClassDetails?.className || null,
    tagColor: shareSecurityClassDetails?.tagColor || '#F56767',
    classCode: shareSecurityClassDetails?.classCode || null,
    currency:
      currencyOptions.find((currencyId) => currencyId?.name?.split(' ')[0] === companyCurrency)
        ?.value ?? null,
    firstClosingDate: shareSecurityClassDetails?.firstClosingDate || null,
    pricePerShare: shareSecurityClassDetails?.pricePerShare || null,
    parValue: shareSecurityClassDetails?.parValue || null,
    seniorityLevel: shareSecurityClassDetails?.seniorityLevel
      ? seniorityOptions.find((value) => value?.value === shareSecurityClassDetails?.seniorityLevel)
      : null,
    votePerShare: shareSecurityClassDetails?.votePerShare || null,
    multiplier: shareSecurityClassDetails?.multiplier || null,
    participating: shareSecurityClassDetails?.participating
      ? participatingOptions.find(
        (value) => value?.value === shareSecurityClassDetails?.participating
      )
      : null,
    participatingCap: shareSecurityClassDetails?.participatingCap || null,
    conversionParameter: shareSecurityClassDetails?.conversionParameter
      ? {
        label: shareSecurityClassDetails?.conversionParameter,
        value: shareSecurityClassDetails?.conversionParameter,
      }
      : null,
    conversionParameterValue: shareSecurityClassDetails?.conversionParameterValue || null,
    fileIds: shareSecurityClassDetails?.documents?.map((document: any) => document.fileId) || [],
  }

  useEffect(() => {
    if (shareSecurityClassDetails?.documents.length > 0 && isNotInitialized) {
      setFiles(
        shareSecurityClassDetails?.documents.map(
          ({ fileId, name }: { fileId: string; name: string }) => ({
            id: fileId,
            name,
          })
        )
      )
    }
  }, [isNotInitialized, shareSecurityClassDetails?.documents]) // eslint-disable-line react-hooks/exhaustive-deps

  const deleteFile = () => {
    if (!deleteFileId) return
    setDeleteLoading(true)
    setFiles(files.filter((file: any) => file.id !== deleteFileId))
    if (formikRef.current) {
      formikRef.current.setFieldValue(
        'fileIds',
        files.filter((file: any) => file.id !== deleteFileId).map((file: any) => file.id)
      )
    }
    toast.success('Document deleted successfully')
    setDeleteLoading(false)
    setDeleteShowModal(false)
  }

  const fetchShareSecurityClassDetails = async () => {
    if (!shareClassId) return
    setShareClassDetailsLoading(true)
    try {
      const {
        data: { success, data },
      } = await getShareSecurityClassById(companyId!, shareClassId)
      if (success && data) {
        setShareSecurityClassDetails(data)
        setSelectedColor(data?.tagColor)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setShareClassDetailsLoading(false)
    }
  }

  useEffect(() => {
    fetchShareSecurityClassDetails()
  }, [shareClassId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = async (values: any, { resetForm }: any) => {
    const rawPayload = {
      shareType: values?.shareType,
      className: values?.className,
      tagColor: values?.tagColor,
      classCode: values?.classCode,
      currency: values?.currency?.value || values?.currency?.id,
      firstClosingDate: values?.firstClosingDate,
      pricePerShare: parseInt(values?.pricePerShare),
      parValue: parseInt(values?.parValue),
      seniorityLevel: values?.seniorityLevel?.value || values?.seniorityLevel?.id,
      votePerShare: parseInt(values?.votePerShare),
      multiplier: parseInt(values?.multiplier),
      participating: values?.participating?.value || values?.participating?.id,
      participatingCap: parseInt(values?.participatingCap),
      conversionParameter: values?.conversionParameter?.value || values?.conversionParameter?.id,
      conversionParameterValue: parseInt(values?.conversionParameterValue),
      fileIds: values?.fileIds,
    }

    const payload = Object.fromEntries(
      Object.entries(rawPayload).filter(
        ([_, value]) =>
          value !== null &&
          value !== undefined &&
          value !== '' &&
          (!isNaN(value) || typeof value === 'string' || Array.isArray(value))
      )
    )

    try {
      if (!companyId) {
        return
      }
      setLoading(true)
      if (shareClassId && shareSecurityClassDetails) {
        const {
          data: { data, success, errors },
        } = await updateShareSecurityClass(payload, companyId, shareClassId)

        if (success) {
          resetForm()
          setFiles([])
          setShareSecurityClassDetails(null)
          setIsCreateOrUpdate(true)

          if (shareClassDropdown) {
            if (setShareClassDropdown) {
              if (openModal) {
                if (modalType === 'AddConvertibleClassModal') {
                  setCreatedShareClassFromOtherClasses(data.shareClassId)
                  openModal('AddConvertibleClassModal')
                } else if (modalType === 'AddWarrantClassModal') {
                  setCreatedShareClassFromOtherClasses(data.shareClassId)
                  openModal('AddWarrantClassModal')
                } else if (modalType === 'AddSharesTransaction') {
                  setCreatedShareClassFromOtherClasses(data.shareClassId)
                  openModal('AddSharesTransaction')
                } else if (modalType === 'AddBuybackTransaction') {
                  openModal('AddBuybackTransaction')
                }
                if (setModalType) {
                  setModalType('none')
                }
              }
              setShareClassDropdown(false)
              setSidebar(2)
            }
          } else {
            setIsActive()
            setSidebar(1)
          }

          setLoading(false)
          toast.success(formatMessage({ id: 'Share security class updated successfully' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ShareSecurityClassUpdateSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                share_class_id: shareClassId,
                share_class_details: payload,
              },
            },
          })
        } else {
          toast.error(errors[0])
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ShareSecurityClassUpdateFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                share_class_id: shareClassId,
                share_class_details: payload,
                error: errors[0],
              },
            },
          })
        }
      } else {
        const {
          data: { data, success, errors },
        } = await createShareSecurityClass(payload, companyId)

        if (success) {
          toast.success(formatMessage({ id: 'Share security class created successfully' }))
          resetForm()
          setFiles([])
          setShareSecurityClassDetails(null)
          setLoading(false)
          setIsCreateOrUpdate(true)
          setSidebar(1)

          if (shareClassDropdown) {
            if (setShareClassDropdown) {
              if (openModal) {
                if (modalType === 'AddConvertibleClassModal') {
                  setCreatedShareClassFromOtherClasses(data.shareClassId)
                  openModal('AddConvertibleClassModal')
                } else if (modalType === 'AddWarrantClassModal') {
                  setCreatedShareClassFromOtherClasses(data.shareClassId)
                  openModal('AddWarrantClassModal')
                } else if (modalType === 'AddSharesTransaction') {
                  setCreatedShareClassFromOtherClasses(data.shareClassId)
                  openModal('AddSharesTransaction')
                } else if (modalType === 'AddBuybackTransaction') {
                  openModal('AddBuybackTransaction')
                }
                if (setModalType) {
                  setModalType('none')
                }
              }
              setShareClassDropdown(false)
              setSidebar(2)
            }
          } else {
            setIsActive()
            setSidebar(1)
          }
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.AddShareSecurityClassSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                share_class_id: shareClassId,
                share_class_details: payload,
              },
            },
          })
        } else {
          toast.error(errors[0])
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.AddShareSecurityClassFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                share_class_id: shareClassId,
                share_class_details: payload,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.error('Error:', err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.AddShareSecurityClassFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            share_class_id: shareClassId,
            share_class_details: payload,
            error: err,
          },
        },
      })
    } finally {
      setLoading(false)
    }
  }

  const nextStep = async () => {
    if (
      currentDocumentStep < 3 &&
      formikRef.current &&
      formikRef.current.values.shareType === 'preferred'
    ) {
      if (currentDocumentStep === 2) {
        await setCurrentSchemaAsync(validationSchema[1])

        if (formikRef.current) {
          await formikRef.current.validateForm()
        }
      }
      setCurrentDocumentStep((prev) => prev + 1)
    } else if (currentDocumentStep < 2) {
      setCurrentDocumentStep((prev) => prev + 1)
    }
  }

  const prevStep = async () => {
    if (currentDocumentStep > 1) {
      if (
        currentDocumentStep === 3 &&
        formikRef.current &&
        formikRef.current.values.shareType === 'preferred'
      ) {
        await setCurrentSchemaAsync(validationSchema[0])

        if (formikRef.current) {
          await formikRef.current.validateForm()
        }
      }
      setCurrentDocumentStep((prev) => prev - 1)
    }
  }

  const setCurrentSchemaAsync = async (newSchema: any) => {
    return new Promise<void>((resolve) => {
      setCurrentSchema(newSchema)
      resolve()
    })
  }

  const [selectedColor, setSelectedColor] = useState('#F56767')
  const colors = [
    { color: '#F56767', id: 'red' },
    { color: '#AA72E8', id: 'purple' },
    { color: '#B30B30', id: 'darkRed' },
    { color: '#FF66FF', id: 'pink' },
    { color: '#66CC66', id: 'green' },
    { color: '#FFD700', id: 'yellow' },
    { color: '#3399FF', id: 'blue' },
  ]

  const handleColorClick = (color: any) => {
    if (formikRef.current) {
      formikRef.current.setFieldValue('tagColor', color)
    }
    setSelectedColor(color)
  }
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={currentSchema}
        onSubmit={handleSubmit}
        innerRef={formikRef}
        enableReinitialize
        validateOnMount
      >
        {(formik) => {
          return (
            <Form>
              <Modal show={isActive} onHide={() => setIsActive()} size='lg' fullscreen>
                <Modal.Header closeButton>
                  <h2>
                    {formatMessage({ id: shareClassId ? 'Edit Share Class' : 'Add Share Class' })}
                  </h2>
                </Modal.Header>
                <Modal.Body className='container'>
                  <div
                    className='stepper stepper-pills stepper-column d-flex flex-column'
                    id='kt_create_account_stepper'
                  >
                    <div className='d-flex justify-content-start flex-column w-100'>
                      <div className='card-body px-0 d-flex justify-content-start'>
                        <div
                          className='d-flex gap-6 align-items-center'
                          style={{
                            overflowX: 'auto',
                            whiteSpace: 'nowrap',
                            scrollbarWidth: 'none',
                            msOverflowStyle: 'none',
                          }}
                        >
                          {[1, 2, 3].map((step) => {
                            return (
                              <div
                                key={step}
                                className={`stepper-item ${currentDocumentStep === step ? 'current' : ''
                                  } custom-marign-right`}
                                style={{ display: 'inline-block' }}
                              >
                                <div className='stepper-wrapper'>
                                  {(step === 1 || step === 2) && (
                                    <div className='stepper-icon w-40px h-40px'>
                                      <i className='stepper-check'></i>
                                      <span className='stepper-number'>{step}</span>
                                    </div>
                                  )}
                                  {step === 3 && formik.values.shareType === 'preferred' && (
                                    <div className='stepper-icon w-40px h-40px'>
                                      <i className='stepper-check'></i>
                                      <span className='stepper-number'>{step}</span>
                                    </div>
                                  )}

                                  <div className='stepper-label'>
                                    <h3 className='stepper-title fw-semibold font-size-13'>
                                      {step === 1 && (
                                        <>
                                          {formatMessage({
                                            id: 'Step 1',
                                          })}
                                        </>
                                      )}
                                      {step === 2 && (
                                        <>
                                          {formatMessage({
                                            id: 'Step 2',
                                          })}
                                        </>
                                      )}
                                      {step === 3 && formik.values.shareType === 'preferred' && (
                                        <>
                                          {formatMessage({
                                            id: 'Step 3',
                                          })}
                                        </>
                                      )}
                                    </h3>
                                    <div className='stepper-desc font-size-12'>
                                      {step === 1 && (
                                        <>
                                          {formatMessage({
                                            id: 'Basic Details',
                                          })}
                                        </>
                                      )}
                                      {step === 2 && (
                                        <>
                                          {formatMessage({
                                            id: 'Documents',
                                          })}
                                        </>
                                      )}
                                      {step === 3 && formik.values.shareType === 'preferred' && (
                                        <>
                                          {formatMessage({
                                            id: 'Terms and Preferences',
                                          })}
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    </div>

                    <div className='d-flex flex-column justify-content-between'>
                      <div className=''>
                        {/* Step 1  */}
                        {currentDocumentStep === 1 && (
                          <div className='w-100'>
                            <InfoCard2
                              title={formatMessage({ id: 'How to Add Share Class?' })}
                              desc={formatMessage({
                                id: 'Specify important information about a company’s share class, including share class name, class code, vote per share, relevant documents, liquidation preferences etc. Adding these details during the initialization of the share class is crucial for accurate dealings with cap table entries & investors later.',
                              })}
                              slug={brandingConfig.helpLinks.addShareClass}
                              className='w-100 mb-0'
                            />

                            <div className='mb-4'>
                              <div className='d-md-flex flex-md-column my-8 mb-8 px-3 px-md-0'>
                                <div className='d-flex form-label  text-dark font-size-13'>
                                  {formatMessage({ id: 'Class Type' })}{' '}
                                  <ToolTipUIForModal
                                    tooltipText={formatMessage({
                                      id: 'GLOBAL.TOOLTIP.SECURITY_CLASS.ADD_SHARED_CLASS.CLASS_TYPE',
                                    })}
                                  />
                                </div>
                                <div className='d-flex align-items-center gap-4'>
                                  <div className='d-flex align-items-center gap-1'>
                                    <input
                                      type='radio'
                                      id='common'
                                      name='shareType'
                                      value='common'
                                      checked={formik.values.shareType === 'common'}
                                      onChange={formik.handleChange}
                                      width={48}
                                      height={48}
                                    />
                                    <label htmlFor='common'>{formatMessage({ id: 'Common' })}</label>
                                  </div>
                                  <div className='d-flex align-items-center gap-1'>
                                    <input
                                      type='radio'
                                      id='preferred'
                                      name='shareType'
                                      value='preferred'
                                      checked={formik.values.shareType === 'preferred'}
                                      onChange={formik.handleChange}
                                      width={48}
                                      height={48}
                                    />
                                    <label htmlFor='preferred'>
                                      {formatMessage({ id: 'Preferred' })}
                                    </label>
                                  </div>
                                </div>
                              </div>

                              {shareClassDetailsLoading ? (
                                <div className='mt-md-8 w-100 px-5 px-md-0 mb-4'>
                                  <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                    <div className='col-md-5 mb-10 mb-md-0'>
                                      <div className='w-50'>
                                        <Skeleton
                                          height={20}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                      <div className='mt-2'>
                                        <Skeleton
                                          height={30}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                    </div>
                                    <div className='col-md-5'>
                                      <div className='w-50'>
                                        <Skeleton
                                          height={20}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                      <div className='mt-2'>
                                        <Skeleton
                                          height={30}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                    <div className='col-md-5 mb-10 mb-md-0'>
                                      <div className='w-50'>
                                        <Skeleton
                                          height={20}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                      <div className='mt-2'>
                                        <Skeleton
                                          height={30}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                    </div>
                                    <div className='col-md-5'>
                                      <div className='w-50'>
                                        <Skeleton
                                          height={20}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                      <div className='mt-2'>
                                        <Skeleton
                                          height={30}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                    <div className='col-md-5 mb-10 mb-md-0'>
                                      <div className='w-50'>
                                        <Skeleton
                                          height={20}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                      <div className='mt-2'>
                                        <Skeleton
                                          height={30}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                    </div>
                                    <div className='col-md-5'>
                                      <div className='w-50'>
                                        <Skeleton
                                          height={20}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                      <div className='mt-2'>
                                        <Skeleton
                                          height={30}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                    <div className='col-md-5 mb-10 mb-md-0'>
                                      <div className='w-50'>
                                        <Skeleton
                                          height={20}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                      <div className='mt-2'>
                                        <Skeleton
                                          height={30}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                    </div>
                                    <div className='col-md-5'>
                                      <div className='w-50'>
                                        <Skeleton
                                          height={20}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                      <div className='mt-2'>
                                        <Skeleton
                                          height={30}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className='w-100 mt-10'>
                                  <div className='row'>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='text'
                                        label={formatMessage({ id: 'Share Class Name' })}
                                        fieldName='className'
                                        formik={formik}
                                        placeholder={formatMessage({ id: 'Enter Share Class Name' })}
                                        toolTipText={formatMessage({
                                          id: 'GLOBAL.TOOLTIP.SECURITY_CLASS.ADD_SHARED_CLASS.CLASS_NAME',
                                        })}
                                        isStarRequired={true}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>

                                    <div className='col-md-6 col-12 mb-8'>
                                      <div className='d-flex'>
                                        <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                                          {formatMessage({ id: 'Select Tag Color *' })}
                                        </label>
                                        <ToolTipUIForModal tooltipText='select tag color for share class' />
                                      </div>
                                      <div className='d-flex align-items-center'>
                                        {colors.map((colorObj) => (
                                          <div
                                            key={colorObj.id}
                                            onClick={() => handleColorClick(colorObj.color)}
                                            className='me-2 rounded-circle mt-1'
                                            style={{
                                              backgroundColor: colorObj.color,
                                              width: '30px',
                                              height: '30px',
                                              border:
                                                selectedColor === colorObj.color
                                                  ? '3px solid black'
                                                  : 'none',
                                              cursor: 'pointer',
                                            }}
                                          />
                                        ))}
                                      </div>
                                    </div>

                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='text'
                                        label={formatMessage({ id: 'Share Class Code' })}
                                        fieldName='classCode'
                                        formik={formik}
                                        placeholder={formatMessage({ id: 'Enter Share Class Code' })}
                                        toolTipText={formatMessage({
                                          id: 'GLOBAL.TOOLTIP.SECURITY_CLASS.ADD_SHARED_CLASS.CLASS_CODE',
                                        })}
                                        isStarRequired={false}
                                        isTooltipForModal={true}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <SelectInput
                                        label={formatMessage({ id: 'Currency' })}
                                        fieldName='currency'
                                        placeholder={formatMessage({
                                          id: 'Select Currency',
                                        })}
                                        formik={formik}
                                        toolTipText={formatMessage({
                                          id: 'GLOBAL.TOOLTIP.SECURITY_CLASS.ADD_SHARED_CLASS.CLASS_CURRENCY',
                                        })}
                                        options={currencyOptions}
                                        isTooltipForModal={true}
                                        disabled={true}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='date'
                                        label={formatMessage({ id: 'Date (First Closing)' })}
                                        fieldName='firstClosingDate'
                                        formik={formik}
                                        isDateOfBirth
                                        placeholder={formatMessage({
                                          id: 'Enter Date (First Closing)',
                                        })}
                                        toolTipText={formatMessage({
                                          id: 'GLOBAL.TOOLTIP.SECURITY_CLASS.ADD_SHARED_CLASS.FIRST_CLOSING_DATE',
                                        })}
                                        isStarRequired={true}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='number'
                                        label={formatMessage({ id: 'Price per share' })}
                                        fieldName='pricePerShare'
                                        formik={formik}
                                        placeholder={formatMessage({ id: 'Enter Price Per Share' })}
                                        toolTipText={formatMessage({
                                          id: 'GLOBAL.TOOLTIP.SECURITY_CLASS.ADD_SHARED_CLASS.PRICE_PER_SHARE',
                                        })}
                                        isStarRequired={true}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='number'
                                        label={formatMessage({ id: 'Par (Face) Value' })}
                                        fieldName='parValue'
                                        formik={formik}
                                        placeholder={formatMessage({ id: 'Enter Face Value' })}
                                        toolTipText={formatMessage({
                                          id: 'GLOBAL.TOOLTIP.SECURITY_CLASS.ADD_SHARED_CLASS.FACE_VALUE',
                                        })}
                                        isStarRequired={false}
                                        isTooltipForModal={true}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='number'
                                        label={formatMessage({ id: 'Vote Per Share' })}
                                        fieldName='votePerShare'
                                        formik={formik}
                                        placeholder={formatMessage({ id: 'Enter Vote Per Share' })}
                                        toolTipText={formatMessage({
                                          id: 'GLOBAL.TOOLTIP.SECURITY_CLASS.ADD_SHARED_CLASS.VOTE_PER_SHARE',
                                        })}
                                        isStarRequired={false}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Step 2  */}
                        {currentDocumentStep === 2 && (
                          <div className='w-100'>
                            <InfoCard2
                              title={formatMessage({ id: 'How to Add Share Class?' })}
                              desc={formatMessage({
                                id: 'Specify important information about a company’s share class, including share class name, class code, vote per share, relevant documents, liquidation preferences etc. Adding these details during the initialization of the share class is crucial for accurate dealings with cap table entries & investors later.',
                              })}
                              slug={brandingConfig.helpLinks.addShareClass}
                              className='w-100 mb-0'
                            />
                            <div className=''>
                              <div className='d-inline-flex form-label  text-dark font-size-13 mt-4'>
                                {formatMessage({ id: 'Attach files' })}{' '}
                                <ToolTipUIForModal
                                  tooltipText={formatMessage({
                                    id: 'Add/upload documents pertaining to this Share Class like side letter, shareholding agreements, etc.',
                                  })}
                                />
                              </div>
                              <div className='w-100'>
                                <button
                                  className='btn btn-primary border border-1 mb-2 px-6 py-4 text-center w-100 w-md-auto'
                                  onClick={() => setModelStatus(true)}
                                >
                                  {formatMessage({ id: 'Import Files' })}
                                </button>
                              </div>
                            </div>

                            <div className='mb-4'>
                              {files.length > 0 && (
                                <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                                  {formatMessage({ id: 'Uploaded Files' })}{' '}
                                  <ToolTipUIForModal
                                    tooltipText={formatMessage({
                                      id: 'Manage all the uploaded documents here.',
                                    })}
                                  />
                                </div>
                              )}
                              <FileUpload
                                fileSize={parseInt(
                                  process.env.REACT_APP_STAKEHOLDERS_MAX_FILE_SIZE as string
                                )}
                                maxFileNumber={10}
                                allowType={allowedFileTypes}
                                metaData={{ module: 'document', isProtected: false }}
                                modalStatus={modelStatus}
                                handleClose={() => {
                                  TagManager.dataLayer({
                                    dataLayer: {
                                      event:
                                        GTMEvent.ShareSecurityClassCreateOrUpdateDocumentsUploadFailed,
                                      action: 'normal',
                                      metadata: {
                                        company_id: companyId,
                                        user_id: currentUser?.userId,
                                        email: currentUser?.email,
                                      },
                                    },
                                  })
                                  setModelStatus(false)
                                }}
                                handleSuccess={(id: number, name: string) => {
                                  setIsNotInitiaized(false)

                                  setFiles((prevFiles: any) => [...prevFiles, { id, name }])

                                  if (formikRef.current) {
                                    const currentFileIds = Array.isArray(
                                      formikRef.current.values.fileIds
                                    )
                                      ? formikRef.current.values.fileIds
                                      : []

                                    fileRef.current.push(id) // Store only the current ID
                                    const uniqueFileIds = Array.from(
                                      new Set([...currentFileIds, ...fileRef.current])
                                    )

                                    formikRef.current.setFieldValue('fileIds', uniqueFileIds)
                                    TagManager.dataLayer({
                                      dataLayer: {
                                        event:
                                          GTMEvent.ShareSecurityClassCreateOrUpdateDocumentsUploadSuccessful,
                                        action: 'normal',
                                        metadata: {
                                          company_id: companyId,
                                          user_id: currentUser?.userId,
                                          email: currentUser?.email,
                                          document_name: name,
                                          document_id: id,
                                        },
                                      },
                                    })
                                  }
                                }}
                                resourceType='all'
                              />
                              {shareClassDetailsLoading ? (
                                <>
                                  <div className='w-50'>
                                    <Skeleton
                                      width={'100%'}
                                      height={48}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='w-50'>
                                    <Skeleton
                                      width={'100%'}
                                      height={48}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </>
                              ) : (
                                <div className='w-100'>
                                  <ul className='p-0 m-0'>
                                    {files?.map((file: any) => (
                                      <li
                                        key={file.id}
                                        className='d-flex align-items-center gap-2 text-decoration-none mb-3 w-100 border border-1 p-2'
                                      >
                                        <div className='d-flex justify-content-between align-items-center w-100'>
                                          <div className='w-100 d-flex align-items-center gap-2'>
                                            <img
                                              src={getFileType(file.name)}
                                              alt={file.name}
                                              style={{ height: '30px', width: '30px' }}
                                            />

                                            <p className='p-0 m-0 max-file-width'>
                                              {file.name.split('/').pop()}
                                            </p>
                                          </div>

                                          <button
                                            type='button'
                                            className='btn btn-secondry p-0 m-0  d-flex align-items-start'
                                            onClick={() => {
                                              setDeleteFileId(file.id)
                                              setDeleteShowModal(true)
                                            }}
                                          >
                                            <img src={deleteicon} alt='Delete' />
                                          </button>
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        {formik.values.shareType === 'preferred' && (
                          <>
                            {/* Step 3  */}
                            {currentDocumentStep === 3 && (
                              <div className='w-100'>
                                <InfoCard2
                                  title={formatMessage({ id: 'How to Add Share Class?' })}
                                  desc={formatMessage({
                                    id: 'Specify important information about a company’s share class, including share class name, class code, vote per share, relevant documents, liquidation preferences etc. Adding these details during the initialization of the share class is crucial for accurate dealings with cap table entries & investors later.',
                                  })}
                                  slug={brandingConfig.helpLinks.addShareClass}
                                  className='w-100 mb-0'
                                />

                                {shareClassDetailsLoading ? (
                                  <div className='mt-md-8 w-100 px-5 px-md-0 mb-4'>
                                    <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                      <div className='col-md-5 mb-10 mb-md-0'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                      <div className='col-md-5'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                      <div className='col-md-5 mb-10 mb-md-0'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                      <div className='col-md-5'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                      <div className='col-md-5 mb-10 mb-md-0'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                      <div className='col-md-5'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                      <div className='col-md-5 mb-10 mb-md-0'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                      <div className='col-md-5'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className='w-100 mt-10'>
                                    <div className='row'>
                                      <h2 className='font-size-16 fw-semibold mb-6'>
                                        {formatMessage({ id: 'Liquidation Preferences' })}
                                      </h2>
                                      <div className='col-md-6 col-12'>
                                        <SelectSearchInput
                                          label={formatMessage({ id: 'Seniority Level' })}
                                          fieldName='seniorityLevel'
                                          placeholder={formatMessage({
                                            id: 'Select between Level 1 to Level 5',
                                          })}
                                          formik={formik}
                                          toolTipText={formatMessage({
                                            id: 'GLOBAL.TOOLTIP.SECURITY_CLASS.ADD_SHARED_CLASS.SENIORITY_LEVEL',
                                          })}
                                          options={seniorityOptions}
                                          isStarRequired={false}
                                          isTooltipForModal={true}
                                          onBlur={formik.handleBlur}
                                        />
                                      </div>

                                      <div className='col-md-6 col-12'>
                                        <TextInput
                                          fieldType='number'
                                          label={formatMessage({ id: 'Multiplier' })}
                                          fieldName='multiplier'
                                          formik={formik}
                                          placeholder={formatMessage({ id: 'Enter Multiplier' })}
                                          toolTipText={formatMessage({
                                            id: 'GLOBAL.TOOLTIP.SECURITY_CLASS.ADD_SHARED_CLASS.MULTIPLIER',
                                          })}
                                          isStarRequired={true}
                                          isTooltipForModal={true}
                                          onBlur={formik.handleBlur}
                                        />
                                      </div>

                                      <div className='col-md-6 col-12'>
                                        <SelectSearchInput
                                          label={formatMessage({ id: 'Participating' })}
                                          fieldName='participating'
                                          placeholder={formatMessage({
                                            id: 'Select Participating',
                                          })}
                                          formik={formik}
                                          toolTipText={formatMessage({
                                            id: 'GLOBAL.TOOLTIP.SECURITY_CLASS.ADD_SHARED_CLASS.PARTICIPATING',
                                          })}
                                          options={participatingOptions}
                                          isStarRequired={false}
                                          isTooltipForModal={true}
                                          onBlur={formik.handleBlur}
                                        />
                                      </div>

                                      <div className='col-md-6 col-12'>
                                        <TextInput
                                          fieldType='number'
                                          label={formatMessage({ id: 'Participation Cap' })}
                                          fieldName='participatingCap'
                                          formik={formik}
                                          placeholder={formatMessage({
                                            id: 'Enter Participation Cap',
                                          })}
                                          toolTipText={formatMessage({
                                            id: 'GLOBAL.TOOLTIP.SECURITY_CLASS.ADD_SHARED_CLASS.PARTICIPATING_CAP',
                                          })}
                                          isStarRequired={
                                            formik.values.participating &&
                                              formik.values.participating.value === 'yes'
                                              ? true
                                              : false
                                          }
                                          isTooltipForModal={true}
                                          onBlur={formik.handleBlur}
                                          isDisabled={
                                            !formik.values.participating ||
                                              (formik.values.participating &&
                                                formik.values.participating.value === 'no')
                                              ? true
                                              : false
                                          }
                                        />
                                      </div>

                                      <h2 className='font-size-16 fw-semibold mb-6'>
                                        {formatMessage({ id: 'Conversion Preferences' })}
                                      </h2>
                                      <div className='col-md-6 col-12'>
                                        <SelectSearchInput
                                          label={formatMessage({ id: 'Conversion Parameters' })}
                                          fieldName='conversionParameter'
                                          placeholder={formatMessage({
                                            id: 'Select Conversion Parameters',
                                          })}
                                          formik={formik}
                                          toolTipText={formatMessage({
                                            id: 'GLOBAL.TOOLTIP.SECURITY_CLASS.ADD_SHARED_CLASS.CONVERSION_PARAMETER',
                                          })}
                                          options={conversionParametersOptions}
                                          isTooltipForModal={true}
                                          isStarRequired={false}
                                          onBlur={formik.handleBlur}
                                        />
                                      </div>

                                      {formik.values.conversionParameter &&
                                        (formik.values.conversionParameter.value ===
                                          'conversionRatio' ||
                                          formik.values.conversionParameter.value ===
                                          'conversionPrice') && (
                                          <div className='col-md-6 col-12'>
                                            <TextInput
                                              fieldType='number'
                                              label={formik.values.conversionParameter.label}
                                              fieldName='conversionParameterValue'
                                              formik={formik}
                                              placeholder={
                                                formik.values.conversionParameter.value ===
                                                  'conversionRatio'
                                                  ? formatMessage({ id: 'Enter Conversion Ratio' })
                                                  : formatMessage({ id: 'Enter Conversion Price' })
                                              }
                                              toolTipText={formatMessage({
                                                id: 'GLOBAL.TOOLTIP.SECURITY_CLASS.ADD_SHARED_CLASS.CONVERSION_RATIO',
                                              })}
                                              isStarRequired={true}
                                              isTooltipForModal={true}
                                              onBlur={formik.handleBlur}
                                            />
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer className='container px-0'>
                  <div className='d-flex flex-md-row flex-column justify-content-md-end justify-content-center gap-3 w-100'>
                    {currentDocumentStep > 1 ? (
                      <div>
                        <button
                          type='button'
                          className='btn bg-light custom-button-property text-muted w-100'
                          onClick={prevStep}
                        >
                          {formatMessage({ id: 'Back' })}
                        </button>
                      </div>
                    ) : (
                      <div>
                        <button
                          type='button'
                          className='btn bg-light custom-button-property text-muted w-100'
                          onClick={() => setIsActive()}
                        >
                          {formatMessage({ id: 'Cancel' })}
                        </button>
                      </div>
                    )}
                    <div>
                      {currentDocumentStep < 3 && formik.values.shareType === 'preferred' ? (
                        <button
                          type='button'
                          className='btn bg-primary text-white custom-button-property w-100'
                          disabled={!formik.isValid}
                          onClick={nextStep}
                        >
                          {formatMessage({ id: 'Next' })}
                        </button>
                      ) : currentDocumentStep < 2 ? (
                        <button
                          type='button'
                          className='btn bg-primary text-white custom-button-property w-100'
                          disabled={!formik.isValid}
                          onClick={nextStep}
                        >
                          {formatMessage({ id: 'Next' })}
                        </button>
                      ) : (
                        <button
                          type='submit'
                          className='btn bg-primary text-white custom-button-property'
                          disabled={!formik.isValid || isLoading}
                          onClick={formik.submitForm}
                        >
                          {!isLoading && (
                            <span className='indicator-label font-size-13 p-0'>
                              {formatMessage({ id: 'Submit' })}
                            </span>
                          )}
                          {isLoading && (
                            <span className='indicator-label font-size-13 p-0'>
                              {formatMessage({ id: 'Please wait...' })}
                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </Modal.Footer>
              </Modal>
            </Form>
          )
        }}
      </Formik>
      <DeleteFileConfirmationModal
        setDeleteShowModal={setDeleteShowModal}
        showDeleteModal={showDeleteModal}
        onDeleteSubmit={deleteFile}
        deleteLoading={deleteLoading}
        header='Delete File'
        paragraph='Are you sure you want to delete this file?'
      />
    </>
  )
}
